export default "__VITE_ASSET__nYs_Gk8L__"